(() => {
  const roots = document.querySelectorAll('[data-ef-root]');
  if (!roots.length) return;

  const COMMERCIAL_NAMES = {
    EFR3PL: 'RIVER 3 Plus',
    EFR620: 'RIVER 2 Pro',
    EFD3: 'DELTA 3',
    EFD31500: 'DELTA 3',
    EFDL3MA: 'DELTA 3 2000 Air',
    EFDL3M: 'DELTA 3 Max',
    EFDL3MP: 'DELTA 3 Max Plus',
    EFDL3U: 'DELTA 3 Ultra',
    'EFD-350': 'DELTA 2 Max',
    'EFD-500': 'DELTA Pro',
    EFD521: 'DELTA Pro 3',
    EFFOLD160LW: 'Panel Solar Bifacial 160W',
    EFFOLD400LW: 'Panel Solar 400W',
    EFPD303: 'Smart Home Panel 2'
  };

  const numberFrom = (raw) => {
    if (!raw) return 0;
    const normalized = String(raw).replace(/,/g, '');
    const n = parseFloat(normalized);
    return Number.isFinite(n) ? n : 0;
  };

  const parseCapacity = (title) => {
    const m = String(title || '').match(/([\d,.]+)\s*Wh\b/i);
    return m ? numberFrom(m[1]) : 0;
  };

  const parsePower = (title) => {
    const text = String(title || '');
    const patterns = [
      /Salida(?:\s+(?:AC|CA))?\s*([\d,.]+)\s*W/i,
      /(?:AC|CA)\s*([\d,.]+)\s*W/i,
      /([\d,.]+)\s*W\s*(?:AC|CA)\b/i,
      /\b([\d,.]+)W\s+AC\b/i,
      /Salida\s*([\d,.]+)\s*W/i
    ];
    for (const re of patterns) {
      const m = text.match(re);
      if (m) return numberFrom(m[1]);
    }
    return 0;
  };

  const commercialName = (model, title, capacity = 0, power = 0) => {
    const sku = String(model || '').trim().toUpperCase();
    if (COMMERCIAL_NAMES[sku]) return COMMERCIAL_NAMES[sku];

    const text = String(title || '');
    const explicit = text.match(/\b(RIVER|DELTA)\s+[A-Za-z0-9+ .-]+?(?=\s*[\/|,]|$)/i);
    if (explicit) return explicit[0].replace(/\s+/g, ' ').trim();

    if (/estación/i.test(text) && capacity) {
      return `EcoFlow ${capacity.toLocaleString('es-MX')} Wh`;
    }
    return text;
  };

  const familyForProduct = (product) => {
    const name = String(product.commercial || '').toUpperCase();
    if (name.startsWith('RIVER')) return 'river';
    if (name.includes('DELTA PRO')) return 'delta-pro';
    if (name.startsWith('DELTA')) return 'delta';
    if (product.capacity <= 800) return 'river';
    if (product.capacity >= 3200) return 'delta-pro';
    return 'delta';
  };

  const shortSpecs = (capacity, power) => {
    const specs = [];
    if (capacity) specs.push(`${capacity.toLocaleString('es-MX')} Wh`);
    if (power) specs.push(`${power.toLocaleString('es-MX')} W`);
    return specs.join(' · ');
  };

  roots.forEach((root) => {
    const selector = root.querySelector('[data-ef-selector]');
    const products = Array.from(root.querySelectorAll('[data-ef-product]')).map((el) => {
      const capacity = parseCapacity(el.dataset.title || '');
      const power = parsePower(el.dataset.title || '');
      const product = {
        title: el.dataset.title || '',
        model: el.dataset.model || 'ECOFLOW',
        url: el.dataset.url || '#',
        price: el.dataset.price || '',
        image: el.dataset.image || '',
        available: el.dataset.available === 'true',
        capacity,
        power
      };
      product.commercial = commercialName(product.model, product.title, capacity, power);
      product.family = familyForProduct(product);
      return product;
    }).filter((p) => p.capacity > 0 && p.power > 0)
      .sort((a,b) => a.capacity - b.capacity || a.power - b.power);

    // Clean product-card names and technical specs.
    root.querySelectorAll('[data-ef-product-card]').forEach((card) => {
      const title = card.dataset.title || '';
      const model = card.dataset.model || '';
      const capacity = parseCapacity(title);
      const power = parsePower(title);
      const name = commercialName(model, title, capacity, power);
      const nameEl = card.querySelector('[data-ef-card-name]');
      const specsEl = card.querySelector('[data-ef-card-specs]');
      if (nameEl) {
        nameEl.textContent = name;
        nameEl.title = title;
      }
      if (specsEl) {
        const specs = shortSpecs(capacity, power);
        if (specs) specsEl.textContent = specs;
        else specsEl.hidden = true;
      }
    });

    const inputs = selector ? Array.from(selector.querySelectorAll('input[type="checkbox"][data-watts]:not([data-ef-security-component])')) : [];
    const hourButtons = selector ? Array.from(selector.querySelectorAll('[data-ef-hours]')) : [];
    let hours = 2;

    const loadEl = selector?.querySelector('[data-ef-load]');
    const energyEl = selector?.querySelector('[data-ef-energy]');
    const emptyEl = selector?.querySelector('[data-ef-result-empty]');
    const productEl = selector?.querySelector('[data-ef-result-product]');
    const alternativeEl = selector?.querySelector('[data-ef-alternative]');
    const measuredInput = selector?.querySelector('[data-ef-measured-watts]');
    const securityToggle = selector?.querySelector('[data-ef-security-toggle]');
    const securityConfig = selector?.querySelector('[data-ef-security-config]');
    const securityComponents = selector ? Array.from(selector.querySelectorAll('[data-ef-security-component]')) : [];
    const qtyControls = selector ? Array.from(selector.querySelectorAll('[data-ef-qty]')) : [];
    const breakdownEl = selector?.querySelector('[data-ef-breakdown]');
    const consumptionLabel = selector?.querySelector('[data-ef-consumption-label]');
    const consumptionModeButtons = selector ? Array.from(selector.querySelectorAll('[data-ef-consumption-mode]')) : [];
    const consumptionRealBlock = selector?.querySelector('[data-ef-consumption-real]');
    let consumptionMode = 'calculated';

    const getQty = (key) => {
      const el = selector?.querySelector(`[data-ef-qty="${key}"]`);
      return el ? numberFrom(el.dataset.value) : 0;
    };

    const setQty = (key, value) => {
      const el = selector?.querySelector(`[data-ef-qty="${key}"]`);
      if (!el) return;
      const min = numberFrom(el.dataset.min) || 0;
      const max = numberFrom(el.dataset.max) || 999;
      const next = Math.max(min, Math.min(max, Math.round(value)));
      el.dataset.value = String(next);
      const valueEl = el.querySelector('[data-ef-qty-value]');
      if (valueEl) valueEl.textContent = String(next);
    };

    const securityActive = () => !!securityToggle?.checked;

    const syncSecurityVisibility = () => {
      if (securityConfig) securityConfig.hidden = !securityActive();
    };

    const applyConsumptionMode = (mode, options = {}) => {
      consumptionMode = mode;
      consumptionModeButtons.forEach((btn) => btn.classList.toggle('is-active', btn.dataset.efConsumptionMode === mode));
      if (loadEl) loadEl.hidden = mode === 'real';
      if (consumptionRealBlock) consumptionRealBlock.hidden = mode !== 'real';
      if (consumptionLabel) consumptionLabel.textContent = mode === 'real' ? 'Consumo real' : 'Consumo calculado';
      if (mode === 'real' && options.focus) measuredInput?.focus();
    };

    const compute = () => {
      let estimatedWatts = 0;
      let minOutput = 0;
      const parts = [];

      inputs.forEach((input) => {
        if (!input.checked) return;
        const w = numberFrom(input.dataset.watts);
        estimatedWatts += w;
        minOutput = Math.max(minOutput, numberFrom(input.dataset.minOutput));
        const label = input.closest('label')?.querySelector('span')?.textContent?.trim() || input.value;
        parts.push(`${label}: ${Math.round(w)} W`);
      });

      if (securityActive()) {
        const cameras = getQty('cameras') || 8;
        const cameraWatts = cameras * 3.5;
        estimatedWatts += cameraWatts;
        parts.unshift(`${cameras} cámaras: ${cameraWatts.toFixed(cameraWatts % 1 ? 1 : 0)} W`);

        securityComponents.forEach((input) => {
          if (!input.checked) return;
          let qtyKey = '';
          if (input.dataset.efSecurityComponent === 'recorder') qtyKey = 'recorders';
          if (input.dataset.efSecurityComponent === 'security-modem') qtyKey = 'security-modems';
          if (input.dataset.efSecurityComponent === 'poe-switch') qtyKey = 'poe-switches';
          if (input.dataset.efSecurityComponent === 'network-switch') qtyKey = 'network-switches';

          const qty = getQty(qtyKey) || 1;
          const each = numberFrom(input.dataset.watts);
          const total = qty * each;
          estimatedWatts += total;

          const name = input.closest('label')?.querySelector('b')?.textContent?.trim() || input.dataset.efSecurityComponent;
          parts.push(`${qty > 1 ? `${qty} × ` : ''}${name}: ${Math.round(total)} W`);
        });
      }

      const measuredWatts = numberFrom(measuredInput?.value);
      const usingMeasured = consumptionMode === 'real';
      const watts = usingMeasured ? measuredWatts : estimatedWatts;

      // 85% allowance for conversion losses and real-world operating conditions.
      const requiredWh = watts > 0 ? Math.ceil((watts * hours) / 0.85) : 0;
      const requiredOutput = Math.max(Math.ceil(watts * 1.20), minOutput);

      if (loadEl) loadEl.textContent = `${Math.round(estimatedWatts).toLocaleString('es-MX')} W`;
      if (energyEl) energyEl.textContent = `${requiredWh.toLocaleString('es-MX')} Wh`;
      if (breakdownEl) {
        breakdownEl.textContent = usingMeasured
          ? 'Se está usando tu consumo real en lugar de la estimación por equipos.'
          : (parts.length ? parts.join(' + ') : '');
      }

      return { watts, requiredWh, requiredOutput, measured: usingMeasured };
    };

    const eligibleProducts = (req) => {
      const fits = products.filter((p) => p.capacity >= req.requiredWh && p.power >= req.requiredOutput);
      return [
        ...fits.filter((p) => p.available),
        ...fits.filter((p) => !p.available)
      ];
    };

    const fillPrimary = (match) => {
      const image = selector.querySelector('[data-ef-result-image]');
      if (image) { image.src = match.image || ''; image.alt = match.commercial || match.title; }
      const model = selector.querySelector('[data-ef-result-model]');
      if (model) model.textContent = match.model;
      const title = selector.querySelector('[data-ef-result-title]');
      if (title) {
        title.textContent = match.commercial || match.title;
        title.title = match.title;
      }
      const cap = selector.querySelector('[data-ef-result-capacity]');
      if (cap) cap.textContent = `${match.capacity.toLocaleString('es-MX')} Wh`;
      const pow = selector.querySelector('[data-ef-result-power]');
      if (pow) pow.textContent = `${match.power.toLocaleString('es-MX')} W`;
      const price = selector.querySelector('[data-ef-result-price]');
      if (price) price.textContent = match.price;
      const link = selector.querySelector('[data-ef-result-url]');
      if (link) link.href = match.url;
    };

    const fillAlternative = (alt) => {
      if (!alternativeEl) return;
      if (!alt) {
        alternativeEl.hidden = true;
        return;
      }
      alternativeEl.hidden = false;
      const title = alternativeEl.querySelector('[data-ef-alt-title]');
      const specs = alternativeEl.querySelector('[data-ef-alt-specs]');
      const price = alternativeEl.querySelector('[data-ef-alt-price]');
      const link = alternativeEl.querySelector('[data-ef-alt-url]');
      if (title) title.textContent = alt.commercial || alt.title;
      if (specs) specs.textContent = shortSpecs(alt.capacity, alt.power);
      if (price) price.textContent = alt.price;
      if (link) link.href = alt.url;
    };

    const showRecommendation = () => {
      if (!selector || !products.length) return;
      const req = compute();
      if (!req.watts) {
        emptyEl?.removeAttribute('hidden');
        if (productEl) productEl.hidden = true;
        if (alternativeEl) alternativeEl.hidden = true;
        return;
      }

      let candidates = eligibleProducts(req);
      let match = candidates[0];

      // If nothing meets the estimate, show the largest available model as the closest option.
      if (!match) {
        match = [...products]
          .sort((a,b) => Number(b.available) - Number(a.available) || (b.capacity*b.power)-(a.capacity*a.power))[0];
        candidates = match ? [match] : [];
      }
      if (!match) return;

      if (emptyEl) emptyEl.hidden = true;
      if (productEl) productEl.hidden = false;
      fillPrimary(match);

      // Prefer a genuinely larger second option.
      const alt = candidates.find((p) =>
        p.url !== match.url &&
        (p.capacity > match.capacity || p.power > match.power)
      );
      fillAlternative(alt);
    };

    const refreshRecommendationIfVisible = () => {
      compute();
      if (productEl && !productEl.hidden) showRecommendation();
    };

    const refreshAfterEquipmentChange = () => {
      applyConsumptionMode('calculated');
      refreshRecommendationIfVisible();
    };

    inputs.forEach((input) => input.addEventListener('change', refreshAfterEquipmentChange));
    measuredInput?.addEventListener('input', refreshRecommendationIfVisible);

    consumptionModeButtons.forEach((btn) => btn.addEventListener('click', () => {
      applyConsumptionMode(btn.dataset.efConsumptionMode, { focus: true });
      refreshRecommendationIfVisible();
    }));

    securityToggle?.addEventListener('change', () => {
      syncSecurityVisibility();
      refreshAfterEquipmentChange();
    });

    securityComponents.forEach((input) => input.addEventListener('change', refreshAfterEquipmentChange));

    qtyControls.forEach((control) => {
      control.querySelector('[data-ef-qty-minus]')?.addEventListener('click', () => {
        setQty(control.dataset.efQty, numberFrom(control.dataset.value) - 1);
        refreshAfterEquipmentChange();
      });
      control.querySelector('[data-ef-qty-plus]')?.addEventListener('click', () => {
        setQty(control.dataset.efQty, numberFrom(control.dataset.value) + 1);
        refreshAfterEquipmentChange();
      });
    });

    hourButtons.forEach((btn) => btn.addEventListener('click', () => {
      hourButtons.forEach((x) => x.classList.remove('is-active'));
      btn.classList.add('is-active');
      hours = numberFrom(btn.dataset.efHours) || 6;
      refreshRecommendationIfVisible();
    }));
    selector?.querySelector('[data-ef-recommend]')?.addEventListener('click', showRecommendation);

    const presets = {
      home: ['modem','fridge','tv'],
      business: ['modem','pc','laptop'],
      outdoor: ['laptop'],
      security: []
    };

    const applySecurityDefaults = () => {
      if (!securityToggle) return;
      securityToggle.checked = true;
      syncSecurityVisibility();
      setQty('cameras', 8);
      setQty('recorders', 1);
      setQty('security-modems', 1);
      setQty('poe-switches', 1);
      setQty('network-switches', 1);
      securityComponents.forEach((input) => {
        input.checked = ['recorder','security-modem'].includes(input.dataset.efSecurityComponent);
      });
    };

    root.querySelectorAll('[data-ef-preset]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!selector) return;
        const preset = button.dataset.efPreset;
        const wanted = presets[preset] || [];
        inputs.forEach((input) => input.checked = wanted.includes(input.value));

        if (preset === 'security') {
          applySecurityDefaults();
        } else if (securityToggle) {
          securityToggle.checked = false;
          syncSecurityVisibility();
        }

        applyConsumptionMode('calculated');
        compute();
        selector.scrollIntoView({behavior:'smooth', block:'start'});
        window.setTimeout(showRecommendation, 550);
      });
    });

    const filters = Array.from(root.querySelectorAll('[data-ef-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-ef-product-card]'));
    const applyFilter = (kind) => {
      filters.forEach((b) => b.classList.toggle('is-active', b.dataset.efFilter === kind));
      cards.forEach((card) => card.hidden = kind !== 'all' && card.dataset.kind !== kind);
    };
    filters.forEach((btn) => btn.addEventListener('click', () => applyFilter(btn.dataset.efFilter || 'all')));

    root.querySelectorAll('[data-ef-family]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const family = btn.dataset.efFamily;
        filters.forEach((b) => b.classList.remove('is-active'));
        cards.forEach((card) => {
          if (card.dataset.kind !== 'station') {
            card.hidden = true;
            return;
          }
          const title = card.dataset.title || '';
          const model = card.dataset.model || '';
          const capacity = parseCapacity(title);
          const power = parsePower(title);
          const product = {
            capacity,
            power,
            commercial: commercialName(model, title, capacity, power)
          };
          card.hidden = familyForProduct(product) !== family;
        });
        root.querySelector('#EcoFlowProductos')?.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });

    applySecurityDefaults();
    applyConsumptionMode('calculated');
    compute();
  });
})();
